/**
 * Utility function to generate MCP server URLs based on environment
 */

/**
 * Determines the current environment from environment variable
 * @returns {string} Environment name ('prod', 'staging', 'dev', etc.)
 */
const getEnvironment = () => {
  return process.env.REACT_APP_ENVIRONMENT || 'dev';
};

/**
 * Generates the MCP server base URL based on environment
 * @returns {string} MCP server base URL (HTTPS enforced)
 */
export const getMcpBaseUrl = () => {
  const environment = getEnvironment();
  
  if (environment === 'prod') {
    return 'https://mcp.themcp.cloud';
  }
  
  return `https://mcp-${environment}.themcp.cloud`;
};

/**
 * Generates the complete MCP server URL with server ID and secrets
 * @param {string} serverId - The server ID
 * @param {string} serverSecrets - The server secrets
 * @returns {string} Complete MCP server URL
 */
export const getMcpServerUrl = (serverId, serverSecrets) => {
  const baseUrl = getMcpBaseUrl();
  return `${baseUrl}/mcp/${serverId}/${serverSecrets}`;
};

/**
 * Generates the display version of MCP server URL (with masked secrets)
 * @param {string} serverId - The server ID
 * @param {number} maskLength - Length of mask characters (default: 8)
 * @returns {string} Display version of MCP server URL
 */
export const getMcpServerDisplayUrl = (serverId, maskLength = 8) => {
  const baseUrl = getMcpBaseUrl();
  const mask = "*".repeat(maskLength);
  return `${baseUrl}/mcp/${serverId}/${mask}`;
};